export interface FrmEnrollmentCandidate {
  id: string;
  displayName: string | null;
  profileId: string | null;
}

interface CandidatesResponse {
  tenantId: string;
  users: FrmEnrollmentCandidate[];
}

export interface EnrollmentResponse {
  status: 'enrolled';
  tenantId: string;
  actorId: string;
  bindingId: string;
  bindingRevision: string;
  checkedAt: string;
  role: 'tenant_admin' | 'member';
  telegramUserId: string;
}

async function readError(response: Response): Promise<string> {
  const body = await response.json().catch(() => null) as { error?: unknown } | null;
  return typeof body?.error === 'string' ? body.error : `HTTP_${response.status}`;
}

export async function fetchTelegramCandidates(signal?: AbortSignal): Promise<CandidatesResponse> {
  const response = await fetch('/api/membership/v1/telegram/candidates', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
    signal,
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json() as Promise<CandidatesResponse>;
}

export async function enrollTelegramCandidate(
  frmUserId: string,
  botId: string,
): Promise<EnrollmentResponse> {
  const response = await fetch('/api/membership/v1/telegram/enroll', {
    method: 'POST',
    credentials: 'include',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ frmUserId, botId }),
    signal: AbortSignal.timeout(12_000),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json() as Promise<EnrollmentResponse>;
}

export interface TelegramVerification {
  bindingId: string;
  state: 'verified' | 'grace_active' | 'grace_expired' | 'revoked' | 'configuration_error';
  sourceCheckedAt: string | null;
  lastAttemptAt: string | null;
  lastAttemptResult: string | null;
  remainingMs: number;
}

export async function fetchTelegramVerification(signal?: AbortSignal): Promise<{ bindings: TelegramVerification[] }> {
  const response = await fetch('/api/membership/v1/telegram/verification', {
    credentials: 'include', headers: { Accept: 'application/json' }, signal,
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
}
